<template>
    <tr style="background: #fafafa">
        <td></td>
        <td :colspan="colspan*2 + 1">
            <div style="margin-top: 20px;">
                <h3>Campaign</h3>
            </div>
            <div class="cd-section" style="margin-bottom: 20px;">
                <input class="form-control" v-model="row.name"></input>
            </div>
        </td>
        <td></td>
    </tr>
</template>

<script>
import SideBySideRowLvl2WarningCell from "./side-by-side-row-lvl2-warning-cell";

export default {
    components: {SideBySideRowLvl2WarningCell},
    props: [
        'row', 'colspan'
    ]
}
</script>
